import React from "react";

const EmptySettlements = () => {

    return (

        <div className="empty-settlements">

            <h2>No Settlements Found</h2>

            <p>

                Provider settlements will appear here once payouts are created.

            </p>

        </div>

    );

};

export default EmptySettlements;